import { render, staticRenderFns } from "./WorkflowStateThresholdFormDialog.vue?vue&type=template&id=7064fca2&"
import script from "./WorkflowStateThresholdFormDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowStateThresholdFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports